import type { ApiParams } from '@Providers';
import { API } from '@Providers';

export default async function (file: File, animalId: string) {
  const formData = new FormData();
  formData.append('animal_id', animalId);
  formData.append('file', file);

  const providerParams: ApiParams = {
    endpoint: `/api/shelter/cart/upload-outcome-temp-file/${animalId}`,
    method: 'post',
    payload: formData,
    isUpload: true,
  };

  return await API({ ...providerParams });
}
